import Axios from '@/common/require'
export default{
  GET_DASHBOARD(store,data){
    return new Promise((resolve, reject) =>{
      Axios({
        url:'/api.php/console/dashboard/index',
        data,
        options:{
          method:'post',
          json:0,
          load:1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js